import useSWR from "swr"

const useYears = () => {
  const { data = [] } = useSWR(`/data/years.json`)
  return data.sort((a, b) => b - a)
}

export default useYears
